import Card from "components/Card/Card";
import {
  GetAllSuppliers,
  searchMedicationForPurchaseOrder,
  AddPurchaseOrder,
  GetPreviousPurchaseOrderData,
  searchMedicationBarcodeForPurchaseOrder,
  AddMedication,
  getAllMedication,
  searchMedicationForOrder,
} from "../../../Listfunction";
import React, { forwardRef, useEffect, useRef, useState } from "react";
import Select from "react-select";
import moment from "moment";
import NotificationSystem from "react-notification-system";
import { useReactToPrint } from "react-to-print";
import BarcodeInput from "./barcode";
import AsyncSelect from "react-select/lib/Async";

import {
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Grid,
  Table,
  Row,
  OverlayTrigger,
  Tooltip,
  Modal,
  Button,
} from "react-bootstrap";
import Datetime from "react-datetime";
import { GetPurchaseOrderHistorydataSupplierWise } from "Listfunction";
import Collapsible from "react-collapsible";
import Swal from "sweetalert2";
import AddMedicationModal from "./AddMedicationModal";
import { AddMedicationFromPO } from "api/purchaseOrder/PurchaseOrder";
import ScreenLoader from "views/Components/screenLoader";
import { getAvailableStock } from "api/purchaseOrder/PurchaseOrder";

const ForwardedFormControl = forwardRef((props, ref) => (
  <input {...props} ref={ref} />
));

const AddPo = (props) => {
  const _notificationSystem = React.createRef();
  const barcodenotification = <Tooltip id="remove">Generate Barcode</Tooltip>;

  const defaultPOItemValues = {
    id: moment().valueOf(),
    item: "",
    description: "",
    item_code: "",
    batch_no: "",
    barcode: null,
    qty: 1,
    unit_price: "",
    discount: 0,
    free_of_good: 0,
    account: 200,
    deals: { value: "B2C", label: "B2C" },
    amount: 0,
    tax_rate: "tax",
    availableStock: 0,
    pack_size: 0,
    pack_price: 0,
    selling_price: 0,
  };

  const [searchMedicineList, setSearchMedicineList] = useState([]);
  const [previousPoId, setpreviousPoId] = useState("");
  const [getMedicine, setGetMedicine] = useState("");
  const [medications, setMedications] = useState([]);
  const [previousBarcode, setpreviousBarcode] = useState("");
  const [searchMedicineListData, setSearchMedicineListData] = useState();
  const [deliveryDate, setDeliveryDate] = useState();
  const [referance, setReference] = useState();
  const [note, setNote] = useState();
  const [barcodeShow, setBarcodeShow] = useState(false);
  const [supplierList, setSupplierList] = useState();
  const [supplierListAllData, setSupplierListAllData] = useState();
  const [poTotal, setPoTotal] = useState(0);
  const [supplierValue, setSupplierValue] = useState(setSupplierList[0]);
  const [poItemValues, setPoItemValues] = useState([defaultPOItemValues]);
  const [supplierError, setSupplierError] = useState(null);
  const [itemError, setItemError] = useState();
  const [typingTimeOut, setTypingTimeOut] = useState(0);
  const [medicineSearch, setMedicineSearch] = useState(0);
  const [supplierMobileNumber, setSupplierMobileNumber] = useState("");
  const [supplierEmail, setSupplierEmail] = useState("");
  const [purchaseOrderHistory, setPurchaseOrderHistory] = useState([]);
  const [rows, setRows] = useState([]);
  const [getDeliveryReason, setGetDeliveryReason] = useState("");
  const [otherOption, setOtherOption] = useState("");
  const [addInvoiceNumber, setAddInvoiceNumber] = useState("");
  const [purchaseOrderHistoryOrderItems, setPurchaseOrderHistoryOrderItems] =
    useState([]);
  const [POHistoryOrderItemsModalShow, setPOHistoryOrderItemsModalShow] =
    useState(false);
  const [accountOption, setAccountOption] = useState([
    { value: 200, label: "Inventory" },
    { value: 425, label: "Freight courier" },
    { value: 311, label: "Cost of good" },
    { value: 313, label: "Sales Sample Cost" },
    { value: 203, label: "Discount Received" },
    { value: 860, label: "Rounding" },
  ]);
  const [disableSubmitButton, setDisableSubmitButton] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedMedicationCategory, setSelectedMedicationCategory] =
    useState(null);
  const [medicationName, setMedicationName] = useState(null);
  const [medicationModalCategoryError, setMedicationModalCategoryError] =
    useState(null);
  const [medicationModalNameError, setMedicationModalNameError] =
    useState(null);
  const [medicationOptions, setMedicationOptions] = useState([]);
  const [localMedicationData, setLocalMedicationData] = useState([]);
  const medIndexRef = useRef([]);
  const medMapRef = useRef({});
  const medSearchCacheRef = useRef({});
  const medSearchRequestSeqRef = useRef(0);
  const loadMedTimerRef = useRef(null);
  // Local draft persistence key
  const DRAFT_KEY = "addPoDraft";
  const [draftRestored, setDraftRestored] = useState(false);

  // Save current form state to localStorage (simple snapshot)
  const saveDraft = () => {
    try {
      const draft = {
        supplierValue,
        addInvoiceNumber,
        deliveryDate,
        referance,
        note,
        poItemValues,
        rows,
        getDeliveryReason,
        otherOption,
        poTotal,
        supplierMobileNumber,
        supplierEmail,
        // timestamp to help determine recency when debugging/merging
        lastModified: Date.now(),
      };
      localStorage.setItem(DRAFT_KEY, JSON.stringify(draft));
    } catch (e) {
      // ignore storage errors (quota, private mode etc.)
      console.warn("Failed to save PO draft:", e);
    }
  };

  // Robust focus helper: tries to focus the element (or call onMenuOpen) with
  // retries. This prevents errors when react-select internals haven't attached
  // yet and avoids calling focus() on null. Best-effort only.
  const safeFocus = (target, attempts = 10, interval = 100) => {
    try {
      if (!target) return;
      let tries = 0;
      const runner = () => {
        try {
          if (!target) return;
          // Some react-select refs expose focus/onMenuOpen directly.
          if (typeof target.focus === "function") {
            target.focus();
            return;
          }
          if (typeof target.onMenuOpen === "function") {
            target.onMenuOpen();
            return;
          }
          // If target has an inputRef (common in some versions), try that.
          if (target.inputRef && typeof target.inputRef.focus === "function") {
            target.inputRef.focus();
            return;
          }
        } catch (e) {
          // swallow - we'll retry below if tries remain
        }
        tries += 1;
        if (tries < attempts) {
          setTimeout(runner, interval);
        }
      };
      runner();
    } catch (e) {
      // ignore
    }
  };

  // Restore draft from localStorage on mount
  useEffect(() => {
    try {
      const raw = localStorage.getItem(DRAFT_KEY);
      if (raw) {
        const d = JSON.parse(raw);
        // Restore primitive / serializable pieces
        if (d.addInvoiceNumber) setAddInvoiceNumber(d.addInvoiceNumber);
        if (d.deliveryDate) setDeliveryDate(d.deliveryDate);
        if (d.referance) setReference(d.referance);
        if (d.note) setNote(d.note);
        if (d.poItemValues) setPoItemValues(d.poItemValues);
        if (d.rows) setRows(d.rows);
        if (d.getDeliveryReason) setGetDeliveryReason(d.getDeliveryReason);
        if (d.otherOption) setOtherOption(d.otherOption);
        if (d.poTotal) setPoTotal(d.poTotal);
        if (d.supplierMobileNumber)
          setSupplierMobileNumber(d.supplierMobileNumber);
        if (d.supplierEmail) setSupplierEmail(d.supplierEmail);
        // supplierValue may be restored fully but supplier list may load later
        if (d.supplierValue) setSupplierValue(d.supplierValue);
        // mark restored so later initialization won't overwrite saved rows
        setDraftRestored(true);
      }
    } catch (e) {
      console.warn("Failed to restore PO draft:", e);
    }
  }, []);

  // Autosave draft whenever important pieces change
  useEffect(() => {
    // throttle-less immediate save is fine for this form
    saveDraft();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    supplierValue,
    addInvoiceNumber,
    deliveryDate,
    referance,
    note,
    poItemValues,
    rows,
    getDeliveryReason,
    otherOption,
  ]);

  const inputRef = useRef(null);
  const barcodeRefs = useRef([]);

  const barcodeRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => {
      return barcodeRef.current[handlePrint.index];
    },
  });

  const onPrintClick = (index) => {
    handlePrint.index = index;
    handlePrint();
  };

  var token = JSON.parse(localStorage.getItem("user"));
  const obj = token.token;
  const store_id = token.store_id;

  let medicationOption = [];

  const inputOnChange = (event) => {
    const val = event.target.value;
    setMedicineSearch(val);

    if (typingTimeOut) {
      clearTimeout(typingTimeOut);
    }
    setTypingTimeOut(
      setTimeout(function () {
        sendToParent(medicineSearch.trim());
      }, 500)
    );
  };

  const sendToParent = async (val) => {
    const res = await searchMedicationForPurchaseOrder(val, obj);

    res.data.data.map((item) => {
      medicationOption.push({
        value: item.item_code,
        label: item.title + "(" + item.item_code + ")",
      });
    });
    setSearchMedicineList(medicationOption);
    setSearchMedicineListData(res.data.data);
  };

  const sendToParentBulk = async (val, index) => {
    const res = await searchMedicationForPurchaseOrder(val, obj);

    res.data.data.map((item) => {
      medicationOption.push({
        value: item.item_code,
        label: item.title,
      });
    });
    setSearchMedicineList(medicationOption);
    setSearchMedicineListData(res.data.data);
    // Do not auto-focus here; focusing should only happen when user explicitly
    // adds a new row via the Add button.
  };
  const sendToParentWhenBarcodeScanned = async (val, id, index) => {
    const res = await searchMedicationBarcodeForPurchaseOrder(val, obj);
    var dataValue = {};
    var selectedMedication = [];

    if (res.data.data.length == 1) {
      res.data.data.map((item) => {
        dataValue.value = item.item_code;
        dataValue.label = item.title;
        selectedMedication = item;
      });
      setPoItemValues((prev) => {
        const itemsDetails = prev.map((poItem) => {
          if (poItem.id === id) {
            return {
              ...poItem,
              item: dataValue,
              unit_price: selectedMedication.unit_price,
              description: selectedMedication.description,
              barcode: selectedMedication.barcode,
              amount: poItem.qty * Number(selectedMedication.unit_price),
              item_code: selectedMedication.item_code,
            };
          }
          return poItem;
        });
        handleTotal(itemsDetails);
        return itemsDetails;
      });
    } else if (res.data.data.length != 0) {
      sendToParentBulk(val.trim(), index);
    }

    setItemError(null);
  };
  const handleSelectChanges = (selectedOption, index) => {
    const duplicate = rows.some(
      (row, i) =>
        i !== index &&
        row.selectedOption &&
        row.selectedOption.value === selectedOption.value
    );

    if (duplicate) {
      Swal.fire({
        width: " 478px",
        title:
          "<div style='font-size:26px;font-weight: 100;'>This medicine is already selected in another row!</div>",
        icon: "warning",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
      return;
    }
    const updatedRows = [...rows];
    updatedRows[index].selectedOption = selectedOption;
    setRows(updatedRows);
  };

  const handleAddMedication = async () => {
    if (!selectedMedicationCategory || !medicationName) {
      if (!selectedMedicationCategory) {
        setMedicationModalCategoryError("Please select a medication category.");
      }
      if (!medicationName) {
        setMedicationModalNameError("Please enter a medication name.");
      }
      return;
    }

    const newMedication = {
      title: medicationName,
      category_id: selectedMedicationCategory.value,
      price: 0,
      item_code: "",
      unit_price: 0,
      country: "1",
      isAvailable: "1",
      description: "",
      is_flash_medicine: "1",
      supplier_id: supplierValue ? supplierValue.value : null,
    };
    setIsLoading(true);
    const addNewMedication = await AddMedicationFromPO(newMedication, obj);
    setIsLoading(false);
    console.log(addNewMedication);
    if (addNewMedication && addNewMedication.data.success) {
      setMedicationModalCategoryError(null);
      setMedicationModalNameError(null);
      setSelectedMedicationCategory(null);
      setMedicationName("");
      setIsOpen(false);

      setPoItemValues((prev) => [
        ...prev,
        {
          id: moment().valueOf(),
          item: {
            value: addNewMedication.data.data.item_code,
            label: addNewMedication.data.data.title,
          },
          account: 200,
          unit_price: 0,
          description: "",
          amount: 0,
          item_code: addNewMedication.data.data.item_code,
          availableStock: 0,
          barcode: "",
          deals: { value: "B2C", label: "B2C" },
          discount: 0,
          free_of_good: 0,
          qty: 1,
        },
      ]);

      // sendToParent(addNewMedication.data.data.item_code)
    } else {
      Swal.fire({
        width: "478px",
        title:
          "<div style='font-size:26px;font-weight: 100;'>Failed to add medication. Please try again.</div>",
        icon: "error",
        showCloseButton: true,
        confirmButtonText: "<span style='font-size:18px;'>OK</span>",
        allowHtml: true,
      });
    }
    console.log("Added Medication:", addNewMedication);
  };

  const handleMedicineSelectChange = async (value, id) => {
    console.log("Value", value);
    const getSelectedMedicine =
      localMedicationData &&
      localMedicationData.find(
        (item) => value && value.value === item.item_code
      );

    console.log("getSelectedMedicine", getSelectedMedicine);

    let availableStockFromApi = 0;
    if (getSelectedMedicine) {
      try {
        const availableStock = await getAvailableStock(
          getSelectedMedicine.id,
          store_id,
          obj
        );
        availableStockFromApi = (availableStock && availableStock.data) || 0;
      } catch (e) {
        console.warn("Failed to fetch available stock:", e);
      }
    }

    setPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        if (poItem.id === id) {
          // If we found the medicine in local data, populate details from it.
          if (getSelectedMedicine) {
            const buyingPrice = Number(getSelectedMedicine.buying_price) || 0;
            const availableStock = availableStockFromApi;

            if (getSelectedMedicine.barcode != null) {
              return {
                ...poItem,
                item: value,
                unit_price: buyingPrice,
                description: getSelectedMedicine.description,
                barcode: getSelectedMedicine.barcode,
                amount: poItem.qty * buyingPrice,
                item_code: getSelectedMedicine.item_code,
                availableStock: availableStock,
                medicineError: null,
                unitPriceError: null,
              };
            }

            return {
              ...poItem,
              item: value,
              unit_price: buyingPrice,
              description: getSelectedMedicine.description,
              amount: poItem.qty * buyingPrice,
              item_code: getSelectedMedicine.item_code,
              availableStock: availableStock,
            };
          }

          // Fallback: selected option not found in localMedicationData
          return {
            ...poItem,
            item: value,
            unit_price: 0,
            description: "",
            amount: 0,
            item_code: value ? value.value : "",
            availableStock: 0,
          };
        }
        return poItem;
      });
      handleTotal(itemsDetails);
      return itemsDetails;
    });
    setItemError(null);
  };
  // const handleSelectChange = (value, id) => {
  //   const selectedMedication =
  //     searchMedicineListData &&
  //     searchMedicineListData.find((Item) => value.value === Item.item_code);
  //   setPoItemValues((prev) => {
  //     const itemsDetails = prev.map((poItem) => {
  //       if (poItem.id === id) {
  //         if (selectedMedication.barcode != null) {
  //           return {
  //             ...poItem,
  //             item: value,
  //             unit_price: Number(selectedMedication.buying_price),
  //             description: selectedMedication.description,
  //             barcode: selectedMedication.barcode,
  //             amount: poItem.qty * Number(selectedMedication.buying_price),
  //             item_code: selectedMedication.item_code,
  //             availableStock:
  //               Number(selectedMedication.total_quantity) -
  //               Number(selectedMedication.total_allocated),
  //             medicineError: null,
  //             unitPriceError: null,
  //           };
  //         } else {
  //           return {
  //             ...poItem,
  //             item: value,
  //             unit_price: Number(selectedMedication.buying_price),
  //             description: selectedMedication.description,
  //             amount: poItem.qty * Number(selectedMedication.buying_price),
  //             item_code: selectedMedication.item_code,
  //             availableStock:
  //               Number(selectedMedication.total_quantity) -
  //               Number(selectedMedication.total_allocated),
  //           };
  //         }
  //       }
  //       return poItem;
  //     });
  //     handleTotal(itemsDetails);
  //     return itemsDetails;
  //   });
  //   setItemError(null);
  // };

  const yesterday = moment().subtract(1, "day");
  const disablePastDt = (current) => {
    return current.isAfter(yesterday);
  };

  const handleQtyChange = (event, id) => {
    const quantity = event.target.value;

    setPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            qty: quantity,
            amount: quantity * poItem.unit_price,
            qtyError: null,
          };
        }
        return poItem;
      });

      handleTotal(itemsDetails);
      return itemsDetails;
    });
  };
  const handleGetDeliveryReason = (value) => {
    setGetDeliveryReason(value);
  };
  const handleUnitPriceChange = (event, id) => {
    const uniPrice = event.target.value;
    setPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        const totalAmount = Number(uniPrice) * poItem.qty;
        const discountAmount = totalAmount * (poItem.discount / 100);
        const amountAfterDiscount = Number(totalAmount - discountAmount);
        if (poItem.id === id) {
          return {
            ...poItem,
            unit_price: uniPrice,
            amount: amountAfterDiscount,
            unitPriceError: null,
          };
        }
        return poItem;
      });
      handleTotal(itemsDetails);
      return itemsDetails;
    });
  };

  const handleDiscountChange = (event, id) => {
    const discountValue = event.target.value;

    setPoItemValues((prev) => {
      const itemsDetails = prev.map((poItem) => {
        if (poItem.id === id) {
          const totalAmount = poItem.qty * poItem.unit_price;
          const discountedAmount =
            totalAmount - (discountValue / 100) * totalAmount;
          return {
            ...poItem,
            discount: discountValue,
            amount: discountedAmount,
          };
        }
        return poItem;
      });
      handleTotal(itemsDetails);
      return itemsDetails;
    });
  };

  const handleFreeOfGoodChange = (event, id) => {
    const freeOfGood = event.target.value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            free_of_good: freeOfGood,
          };
        }
        return poItem;
      })
    );
  };

  const handleDescriptionChange = (event, id) => {
    const description = event.target.value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            description: description,
          };
        }
        return poItem;
      })
    );
  };

  const handleBatchNoChange = (event, id) => {
    const batch_no = event.target.value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            batch_no: batch_no,
          };
        }
        return poItem;
      })
    );
  };
  const handleBarcodeNoChange = (event, id, index) => {
    const barcode = event.target.value;
    if (barcode.trim()[0] == "F") {
      if (barcode.length == 8) {
        if (previousPoId != id) {
          sendToParentWhenBarcodeScanned(barcode.trim(), id, index);
          setpreviousPoId(id);
          setpreviousBarcode(barcode);
        } else if (previousBarcode != barcode) {
          sendToParentWhenBarcodeScanned(barcode.trim(), id, index);
        }
      }
    } else {
      if (barcode.length == 7) {
        if (previousPoId != id) {
          sendToParentWhenBarcodeScanned(
            barcode.substring(1, 7).trim(),
            id,
            index
          );
          setpreviousPoId(id);
          setpreviousBarcode(barcode);
        } else if (previousBarcode != barcode) {
          sendToParentWhenBarcodeScanned(
            barcode.substring(1, 7).trim(),
            id,
            index
          );
        }
      }
    }

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            barcode: barcode,
          };
        }

        return poItem;
      })
    );
  };

  const handleAccountChange = (value, id) => {
    const accountValue = value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            account: accountValue,
            accountError: null,
          };
        }
        return poItem;
      })
    );
  };

  const handleDeliveryDateChange = (value) => {
    const delivery_date = moment(value).format("YYYY-MM-DD");
    setDeliveryDate(delivery_date);
  };

  const handleReferenceChange = (event) => {
    const referenceValue = event.target.value;
    setReference(referenceValue);
  };

  const handleDeliveryInstructionChange = (event) => {
    const noteValue = event.target.value;
    setNote(noteValue);
  };

  const handleDealsChange = (value, id) => {
    const dealsValue = value;

    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            deals: dealsValue,
          };
        }
        return poItem;
      })
    );
  };

  // async loader for medication select with debounce + cache + request sequencing
  const loadMedicationOptions = (inputValue) => {
    if (!inputValue || inputValue.trim().length < 2) return Promise.resolve([]);

    const q = inputValue.trim();

    // return cached result when available
    if (medSearchCacheRef.current[q]) {
      return Promise.resolve(medSearchCacheRef.current[q]);
    }

    // ensure medIndex is built from localMedicationData when available
    if (
      (!medIndexRef.current || medIndexRef.current.length === 0) &&
      localMedicationData &&
      localMedicationData.length > 0
    ) {
      buildMedIndex(localMedicationData);
    }

    return new Promise((resolve) => {
      if (loadMedTimerRef.current) clearTimeout(loadMedTimerRef.current);
      loadMedTimerRef.current = setTimeout(() => {
        // If we have local data index, filter locally (fast)
        if (medIndexRef.current && medIndexRef.current.length > 0) {
          const lower = q.toLowerCase();
          const results = [];
          const LIMIT = 50;

          // 1) prefix matches
          for (
            let i = 0;
            i < medIndexRef.current.length && results.length < LIMIT;
            i++
          ) {
            const m = medIndexRef.current[i];
            if (m.labelLower.startsWith(lower)) results.push(m);
          }

          // 2) substring matches
          if (results.length < LIMIT) {
            for (
              let i = 0;
              i < medIndexRef.current.length && results.length < LIMIT;
              i++
            ) {
              const m = medIndexRef.current[i];
              if (results.indexOf(m) !== -1) continue;
              if (m.labelLower.includes(lower)) results.push(m);
            }
          }

          // 3) phonetic soundex fallback for longer queries
          if (results.length === 0 && lower.length >= 3) {
            const qSound = soundex(lower);
            for (
              let i = 0;
              i < medIndexRef.current.length && results.length < LIMIT;
              i++
            ) {
              const m = medIndexRef.current[i];
              if (m.soundex && m.soundex === qSound) results.push(m);
            }
          }

          const options = results.map((m) => ({
            value: m.value,
            label: m.label,
          }));

          // cache limited queries
          try {
            const keys = Object.keys(medSearchCacheRef.current);
            if (keys.length > 200) delete medSearchCacheRef.current[keys[0]];
            medSearchCacheRef.current[q] = options;
          } catch (e) {}

          return resolve(options);
        }

        // fallback: call API once (debounced) if no local data
        medSearchRequestSeqRef.current++;
        const reqSeq = medSearchRequestSeqRef.current;
        try {
          const token = JSON.parse(localStorage.getItem("user"));
          const auth = token ? token.token : null;
          const city_id = 1;

          searchMedicationForOrder(q, city_id, 1, auth, store_id)
            .then((res) => {
              if (reqSeq !== medSearchRequestSeqRef.current) return resolve([]);
              const data = (res.data && res.data.data) || [];
              const options = data.map((medication) => ({
                value: medication.item_code,
                label: `${medication.title} (${medication.item_code})`,
              }));
              try {
                const keys = Object.keys(medSearchCacheRef.current);
                if (keys.length > 200)
                  delete medSearchCacheRef.current[keys[0]];
                medSearchCacheRef.current[q] = options;
              } catch (e) {}
              resolve(options);
            })
            .catch(() => resolve([]));
        } catch (e) {
          resolve([]);
        }
      }, 200);
    });
  };

  const handleGetAllMedication = async () => {
    var token = JSON.parse(localStorage.getItem("user"));
    const obj = token.token;
    const store = 1;
    await getAllMedication(obj, store)
      // .then((response) => response.json())
      .then((response) => {
        const mdata = response.data;
        // this.setState({ allMedicine: mdata });
        const medicationOptions = mdata.map((medication) => ({
          value: medication.item_code,
          label: `${medication.title} (${medication.item_code})`,
        }));
        setMedicationOptions(medicationOptions);
        // store local medication data and build a local index for fast
        // client-side lookups (functional component style)
        setLocalMedicationData(mdata);
        if (mdata && mdata.length > 0) {
          buildMedIndex(mdata);
        }
      });
  };

  // Build a simple phonetic code for loose matching (used by buildMedIndex)
  const soundex = (str) => {
    if (!str) return "";
    const s = str.toUpperCase().replace(/[^A-Z]/g, "");
    if (s.length === 0) return "";
    const first = s[0];
    const mapping = {
      B: "1",
      F: "1",
      P: "1",
      V: "1",
      C: "2",
      G: "2",
      J: "2",
      K: "2",
      Q: "2",
      S: "2",
      X: "2",
      Z: "2",
      D: "3",
      T: "3",
      L: "4",
      M: "5",
      N: "5",
      R: "6",
    };
    let prev = mapping[first] || "";
    let out = first;
    for (let i = 1; i < s.length && out.length < 4; i++) {
      const ch = s[i];
      const code = mapping[ch] || "0";
      if (code === prev) continue;
      if (code !== "0") {
        out += code;
      }
      prev = code;
    }
    return out.padEnd(4, "0").slice(0, 4);
  };

  const buildMedIndex = (medArray) => {
    try {
      medIndexRef.current = medArray.map((m) => {
        const label = `${m.title} (${m.item_code})`;
        const labelLower = (label || "").toLowerCase();
        let sdx = "";
        try {
          sdx = soundex(labelLower);
        } catch (e) {
          sdx = "";
        }
        return { value: m.item_code, label, labelLower, soundex: sdx };
      });
      // sort for stable prefix scanning
      medIndexRef.current.sort((a, b) =>
        a.labelLower > b.labelLower ? 1 : -1
      );

      // build map for quick access to full medication objects
      const map = {};
      medArray.forEach((m) => {
        map[m.item_code] = m;
      });
      medMapRef.current = map;
    } catch (e) {
      medIndexRef.current = [];
      medMapRef.current = {};
    }
  };

  useEffect(() => {
    GetAllSuppliers(obj).then((res) => {
      const supplierOptions = res.data.data.map((supplier) => ({
        value: supplier.id,
        label: supplier.name,
      }));
      setSupplierList(supplierOptions);
      setSupplierListAllData(res.data.data);

      // If a draft was restored earlier that included supplierValue, try to
      // reconcile it with the freshly fetched supplierOptions so Select gets a
      // matching option object (helps to show proper label and behavior).
      try {
        const raw = localStorage.getItem(DRAFT_KEY);
        if (raw) {
          const d = JSON.parse(raw);
          if (d && d.supplierValue) {
            const sv = d.supplierValue;
            const match = supplierOptions.find(
              (s) =>
                String(s.value) === String(sv.value) ||
                String(s.value) === String(sv)
            );
            if (match) setSupplierValue(match);
            else setSupplierValue(sv);
          }
        }
      } catch (e) {
        // ignore
      }
    });
    // Preload all medications once on mount so the local search index is
    // available for `loadMedicationOptions` and avoids repeated API calls.
    try {
      handleGetAllMedication();
    } catch (e) {
      // ignore errors during initial prefetch
    }
  }, []);

  const handleAddClick = () => {
    setSearchMedicineList([]);
    setSearchMedicineListData([]);
    setPoItemValues((prev) => [
      ...prev,
      { ...defaultPOItemValues, id: moment().valueOf() },
    ]);
    // Focus the newly added row's input after render. Use a short timeout so
    // refs have a chance to attach.
    setTimeout(() => {
      try {
        if (inputRef && inputRef.current && inputRef.current.length > 0) {
          const lastIndex = inputRef.current.length - 1;
          const el = inputRef.current[lastIndex];
          if (el) safeFocus(el, 15, 80);
        }
      } catch (err) {
        // ignore
      }
    }, 100);
  };

  // NOTE: removed automatic focusing when `poItemValues` changes. Focusing is
  // now performed only when the user clicks the Add button (see handleAddClick)
  // to avoid unexpected focus behavior during other operations.

  const setBarcodeRef = (el, index) => {
    barcodeRefs.current[index] = el;
  };
  const setBarcodeRefs = (el, index) => {
    if (!barcodeRef.current) {
      barcodeRef.current = {};
    }
    barcodeRef.current[index] = el;
  };
  const setInputRef = (el, index) => {
    // initialize as an array so length checks and numeric indices work as expected
    if (!inputRef.current) {
      inputRef.current = [];
    }
    inputRef.current[index] = el;
    // Intentionally do not auto-focus on ref attachment. Focusing should only
    // happen when the user clicks 'Add' (handled in handleAddClick).
  };

  const handleRemoveClick = (id) => {
    const poItems = [...poItemValues];
    const removeRow = poItems.filter((Item) => Item.id !== id);
    setPoItemValues(removeRow);

    handleTotal(removeRow);
    return removeRow;
  };

  const handlePackSizeChange = (event, id) => {
    const packSize = event.target.value;
    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            pack_size: packSize,
            selling_price:
              poItem.pack_price && packSize
                ? Number(poItem.pack_price) / Number(packSize)
                : 0,
          };
        }
        return poItem;
      })
    );
  };

  const handlePackPriceChange = (event, id) => {
    const packPrice = event.target.value;
    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          return {
            ...poItem,
            pack_price: packPrice,
            selling_price:
              poItem.pack_size && packPrice
                ? Number(packPrice) / Number(poItem.pack_size)
                : 0,
          };
        }
        return poItem;
      })
    );
  };

  const handleSellingPriceChange = (event, id) => {
    // const sellingPrice = event.target.value;
    setPoItemValues((prev) =>
      prev.map((poItem) => {
        if (poItem.id === id) {
          const sellingPrice =
            Number(poItem.pack_price) / Number(poItem.pack_size);
          return {
            ...poItem,
            selling_price: sellingPrice,
          };
        }
        return poItem;
      })
    );
  };

  const handleOnSubmit = async () => {
    let error = false;
    const isMandatoryFieldsFilled = poItemValues.filter(
      (data) =>
        !data.account ||
        data.account === 0 ||
        data.qty == 0 ||
        data.qty == "" ||
        data.unit_price == "" ||
        Number(data.unit_price) == 0
    );
    if (supplierValue === undefined) {
      error = true;
      setSupplierError(
        <small className="text-danger">Supplier is required.</small>
      );
    }
    if (poItemValues.length === 0) {
      error = true;
      setItemError(
        <div class="alert alert-danger" role="alert">
          Please Add atleast one item
        </div>
      );
    }
    if (isMandatoryFieldsFilled.length > 0) {
      error = true;
      const isMandatoryFieldsFilledError = poItemValues.map((data) => {
        let poItem = {
          ...data,
        };
        if (!data.account || data.account === 0) {
          poItem = {
            ...poItem,
            accountError: (
              <small className="text-danger">feild required.</small>
            ),
          };
        }
        if (data.qty == 0 || data.qty == "") {
          poItem = {
            ...poItem,
            qtyError: <small className="text-danger">feild required.</small>,
          };
        }
        if (data.unit_price == "" || Number(data.unit_price) == 0) {
          poItem = {
            ...poItem,
            unitPriceError: (
              <small className="text-danger">feild required.</small>
            ),
          };
        }
        if (data.item == "" || !data.item) {
          poItem = {
            ...poItem,
            medicineError: (
              <small className="text-danger">feild required.</small>
            ),
          };
        }
        return poItem;
      });
      setPoItemValues(isMandatoryFieldsFilledError);
    }
    if (!error) {
      setSupplierError(null);
      const AddPoBody = {
        supplier_id: Number(supplierValue.value),
        order: poItemValues.map((poItem) => {
          return {
            item_code: poItem.item.value,
            free_of_goods: Number(poItem.free_of_good),
            quantity: Number(poItem.qty),
            price: Number(poItem.unit_price),
            deals: poItem.deals.value,
            discount: Number(poItem.discount),
            tax_rate: poItem.tax_rate,
            account: 200,
            description: poItem.description,
            batch_no: poItem.batch_no,
            barcode: poItem.barcode,
            item_code: poItem.item_code,
            selling_price: poItem.selling_price,
            pack_size: poItem.pack_size,
            pack_price: poItem.pack_price,
          };
        }),
        delivery_date: deliveryDate ? deliveryDate : "",
        referance: referance ? referance : "",
        note: note,
        invoice_no: addInvoiceNumber,
        good_return: rows.map((row) => ({
          title: !!row.selectedOption ? row.selectedOption.label : null,
          quantity: parseInt(row.qty),
          price: !!row.selectedOption ? row.selectedOption.unitPrice : null,
          reason:
            getDeliveryReason && getDeliveryReason.value === "Other"
              ? otherOption
              : getDeliveryReason.value,
        })),
        store_id: store_id,
      };
      const notification = _notificationSystem.current;
      try {
        // ensure the latest snapshot is saved before submitting
        saveDraft();

        setDisableSubmitButton(true);
        setIsLoading(true);
        const res = await AddPurchaseOrder(AddPoBody, obj);
        setDisableSubmitButton(false);
        setIsLoading(false);
        if (res.data.success === true) {
          notification.addNotification({
            title: <span data-notify="icon" className="pe-7s-gift"></span>,
            message: (
              <div>
                <b>PO</b> - Added Successfully .
              </div>
            ),
            level: "success",
            position: "bl",
            autoDismiss: 15,
          });
          // clear draft on successful submission
          try {
            localStorage.removeItem(DRAFT_KEY);
          } catch (e) {
            // ignore
          }
          props.history.push("/admin/poList");
        }
      } catch (err) {
        notification.addNotification({
          title: <span data-notify="icon" className="pe-7s-gift"></span>,
          message: (
            <div>
              <b>something went wrong</b>
            </div>
          ),
          level: "error",
          position: "bl",
          autoDismiss: 15,
        });
      }
    }
  };

  const handleTotal = (items) => {
    let total = 0;
    const poItem = [...items];
    poItem.forEach((Item) => {
      total = total + Item.amount;
    });
    setPoTotal(total);
  };
  const hanldeAddInvoiceNumber = (event) => {
    const addInvoiceNumbers = event.target.value;
    setAddInvoiceNumber(addInvoiceNumbers);
  };

  const handleSelectSupplierOnChange = (value) => {
    setSupplierValue(value);
    const selectedSUpplierMobileNumber =
      supplierListAllData &&
      supplierListAllData.find((item) => item.id === Number(value.value));
    setSupplierMobileNumber(selectedSUpplierMobileNumber.mobile);
    setSupplierEmail(selectedSUpplierMobileNumber.email);

    GetPreviousPurchaseOrderData(value.value, obj).then((res) => {
      const defaultValues = res.data.data.items.map((data, index) => {
        const listId = moment().valueOf();
        const previousAccount = accountOption.find(
          (account) => account.value === Number(data.account)
        );
        return {
          id: listId + index,
          item: {
            value: data.item_code,
            label: data.name + "(" + data.item_code + ")",
          },
          description: data.discription,
          qty: data.quantity,
          unit_price: data.price,
          discount:
            data.discount == null || data.discount == ""
              ? 0
              : Number(data.discount),
          free_of_good:
            data.free_of_goods == null || data.free_of_goods == ""
              ? 0
              : Number(data.free_of_goods),
          account: previousAccount,
          deals: { value: data.deals, label: data.deals },
          amount: data.amount,
          barcode: data.barcode,
          tax_rate: "tax",
          name: data.name,
          item_code: data.item_code,
          availableStock:
            Number(data.total_quantity) - Number(data.total_allocated),
        };
      });
      setPoItemValues(defaultValues);
      handleTotal(defaultValues);
    });
  };

  const showPOHistoryData = () => {
    GetPurchaseOrderHistorydataSupplierWise(supplierValue, obj).then((res) => {
      setPurchaseOrderHistory(res.data.data);
    });
  };
  const handleTotalPOAmount = (poHistoryItems) => {
    let totalAmountForPoHistory = 0;
    const total = poHistoryItems.forEach((data) => {
      totalAmountForPoHistory = Number(data.amount) * Number(data.quantity);
    });
    return totalAmountForPoHistory;
  };
  const showPoItemsModal = (POHistoryOrderItems, id) => {
    setPurchaseOrderHistoryOrderItems(POHistoryOrderItems);
    setPOHistoryOrderItemsModalShow(true);
  };
  const handlePOHistoryItemTotal = (orderItem) => {
    let total = 0;
    orderItem.forEach((Item) => {
      total =
        total +
        (Number(Item.amount) * Number(Item.quantity) -
          (Number(Item.discount) / 100) *
            (Number(Item.amount) * Number(Item.quantity)));
    });
    return total.toFixed(2);
  };
  const handleInputChange = (inputValue) => {
    setGetMedicine(inputValue);

    if (inputValue.trim() !== "") {
      searchMedicationForPurchaseOrder(inputValue, obj)
        .then((res) => {
          if (res.success) {
            const selectedIds = rows
              .filter((row) => row.selectedOption)
              .map((row) => row.selectedOption.value);
            const options = res.data.data
              .filter((med) => !selectedIds.includes(med.id))
              .map((med) => ({
                value: med.id,
                label: `${med.medication_name} (${med.item_code})`,
                data: med,
                qty: med.total_quantity - med.total_allocated,
                unitPrice: med.unit_price,
              }));
            setMedications(options);
          }
        })
        .catch((err) => {
          console.error("Error fetching medications", err);
        });
    } else {
      setMedications([]);
    }
  };
  const handleQtyBlur = (e, index) => {
    let value = parseInt(e.target.value, 10);

    if (isNaN(value) || value < 1) {
      value = 1;
    }

    const updatedRows = [...rows];
    updatedRows[index].qty = value.toString();
    setRows(updatedRows);
  };
  const handleRemoveRow = (index) => {
    const updatedRows = rows.filter((_, i) => i !== index);
    setRows(updatedRows);
  };
  const handleQtyChanges = (e, index) => {
    const value = e.target.value;
    const updatedRows = [...rows];
    updatedRows[index].qty = value;
    updatedRows[index].touched = true;
    setRows(updatedRows);
  };
  const handleAddRow = () => {
    setRows([
      ...rows,
      {
        selectedOption: null,
        qty: "1",
      },
    ]);
  };
  const handleRemoveValues = () => {
    setGetDeliveryReason(null);
    setOtherOption(null);
    setRows([]);
  };

  const clearSupplierWisePO = () => {
    const defaultPOItemValues = {
      id: moment().valueOf(),
      item: "",
      description: "",
      item_code: "",
      batch_no: "",
      barcode: null,
      qty: 1,
      unit_price: "",
      discount: 0,
      free_of_good: 0,
      account: 200,
      deals: { value: "B2C", label: "B2C" },
      amount: 0,
      tax_rate: "tax",
      barcode: "",
      availableStock: 0,
      pack_size: 0,
      pack_price: 0,
      selling_price: 0,
    };
    // Reset the form items and totals
    setPoItemValues([defaultPOItemValues]);
    setPoTotal(0);

    // Reset refs that track per-row inputs so any focus logic that uses
    // inputRef.current.length stays in sync with the rendered rows.
    try {
      if (inputRef && inputRef.current) inputRef.current = [];
    } catch (e) {
      // ignore
    }
    try {
      if (barcodeRefs && barcodeRefs.current) barcodeRefs.current = [];
    } catch (e) {
      // ignore
    }
    try {
      if (barcodeRef && barcodeRef.current) barcodeRef.current = {};
    } catch (e) {
      // ignore
    }
    // Also clear any transient search lists so the UI is clean after clearing
    setSearchMedicineList([]);
    setSearchMedicineListData([]);
    // After clearing, focus the first (only) input to improve UX. Use a
    // short timeout so the ref is attached by the time we attempt to focus.
    setTimeout(() => {
      try {
        if (inputRef && inputRef.current && inputRef.current.length > 0) {
          const el = inputRef.current[0];
          if (el) safeFocus(el, 15, 80);
        }
      } catch (e) {
        // ignore
      }
    }, 120);
  };
  console.log("isOpen", isOpen);
  const view = <Tooltip id="view">View PO items</Tooltip>;
  return (
    <>
      {isLoading && <ScreenLoader />}
      <Grid fluid>
        <NotificationSystem ref={_notificationSystem} />
        <br />
        <Card
          content={
            <>
              <div> {itemError}</div>
              <form>
                <div className="table-responsive">
                  <Table
                    style={{ border: "none !important" }}
                    className="fl_order_details"
                  >
                    <thead>
                      <tr>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Supplier</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Invoice Number</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Delivery Date</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Reference</ControlLabel>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <FormGroup>
                            <Select
                              className="react-select primary"
                              name="supplier"
                              value={supplierValue}
                              onChange={(value) =>
                                handleSelectSupplierOnChange(value)
                              }
                              options={supplierList}
                              placeholder="Select Supplier"
                              /* Render the menu into document.body so it can escape overflow/stacking contexts */
                              menuPortalTarget={
                                typeof document !== "undefined"
                                  ? document.body
                                  : null
                              }
                              menuPosition="fixed"
                              styles={{
                                menuPortal: (base) => ({
                                  ...base,
                                  zIndex: 9999,
                                }),
                                menu: (base) => ({ ...base, zIndex: 9999 }),
                              }}
                            />
                            {supplierValue !== undefined ? null : supplierError}
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup>
                            <FormControl
                              className="form-control"
                              placeholder="Enter Po Number"
                              type="text"
                              rows="4"
                              cols="5"
                              name="addInvoiceNumber"
                              onChange={(e) => hanldeAddInvoiceNumber(e)}
                              value={addInvoiceNumber}
                            />
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup>
                            <Datetime
                              timeFormat={false}
                              dateFormat="YYYY-MM-DD"
                              inputProps={{ placeholder: "Delivery Date" }}
                              closeOnSelect={true}
                              onChange={(value) =>
                                handleDeliveryDateChange(value)
                              }
                              isValidDate={disablePastDt}
                            />
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup>
                            <FormControl
                              type="text"
                              name="reference"
                              placeholder="Reference "
                              onChange={(e) => handleReferenceChange(e)}
                            />
                          </FormGroup>
                        </td>
                      </tr>
                    </tbody>
                    <thead>
                      <tr>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Supplier Mobile No.</ControlLabel>
                        </th>
                        <th align="center" style={{ paddingLeft: 0 }}>
                          <ControlLabel>Supplier Email</ControlLabel>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <FormGroup>
                            <FormControl
                              disabled
                              type="text"
                              name="supplierMobileNumber"
                              placeholder="Supplier mobile number "
                              value={supplierMobileNumber}
                            />
                          </FormGroup>
                        </td>
                        <td>
                          <FormGroup>
                            <FormControl
                              disabled
                              type="text"
                              name="supplierEmail"
                              placeholder="Supplier email "
                              value={supplierEmail}
                            />
                          </FormGroup>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
                {!!supplierValue && (
                  <>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        // alignItems: "end",
                        marginRight: "25px",
                        textAlign: "right",
                        justifyContent: "end",
                      }}
                    >
                      <Button
                        style={{ marginLeft: "15px" }}
                        className="btn btn-fill"
                        onClick={() => clearSupplierWisePO()}
                      >
                        <i
                          className="fa fa-refresh"
                          style={{ marginRight: "5px" }}
                        ></i>{" "}
                        Clear PO Items
                      </Button>
                    </div>
                    <hr />
                    <div>
                      <table
                        style={{
                          overflow: "auto",
                          borderCollapse: "separate",
                          borderSpacing: "10px 0",
                          width: "100%",
                        }}
                      >
                        <thead
                          style={{
                            position: "sticky",
                            top: 0,
                            backgroundColor: "white",
                            zIndex: 1000,
                          }}
                        >
                          <tr>
                            <th align="center" style={{ paddingLeft: 0 }}>
                              <ControlLabel>&nbsp;</ControlLabel>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Barcode</ControlLabel>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Item</ControlLabel>
                            </th>
                            {/* <th style={{ textAlign: "center" }}>
                <ControlLabel>Description</ControlLabel>
              </th> */}
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Qty</ControlLabel>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Unit Price</ControlLabel>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Discount</ControlLabel>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Free</ControlLabel>
                            </th>
                            {/* <th style={{ textAlign: "center" }}>
                <ControlLabel>Account</ControlLabel>
              </th> */}
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Pack Size</ControlLabel>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Pack Price</ControlLabel>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Selling Price</ControlLabel>
                            </th>
                            <th style={{ textAlign: "center" }}>
                              <ControlLabel>Amount</ControlLabel>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {poItemValues &&
                            poItemValues.map((poItem, index) => (
                              <tr key={index} style={{ verticalAlign: "top" }}>
                                <td style={{ width: "3%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="text"
                                      name="serial_no"
                                      placeholder="S.No"
                                      value={index + 1}
                                      disabled
                                      style={{
                                        fontSize: "8px",
                                      }}
                                    />
                                  </FormGroup>
                                </td>
                                <td style={{ width: "6%" }}>
                                  <FormGroup>
                                    <ForwardedFormControl
                                      type="text"
                                      name="Barcode"
                                      placeholder="Barcode"
                                      style={{
                                        backgroundColor: "#ffffff",
                                        border: "1px solid #e3e3e3",
                                        borderRadius: "4px",
                                        color: "#565656",
                                        padding: " 8px 12px",
                                        height: "40px",
                                        boxShadow: "none",
                                        width: "100%",
                                        fontSize: "8px",
                                      }}
                                      onChange={(e) =>
                                        handleBarcodeNoChange(
                                          e,
                                          poItem.id,
                                          index
                                        )
                                      }
                                      ref={(el) => setBarcodeRef(el, index)}
                                      value={
                                        !!poItem.barcode
                                          ? poItem.barcode
                                          : poItem.item_code
                                      }
                                    />
                                  </FormGroup>
                                </td>
                                <td style={{ width: "25%", paddingTop: "5px" }}>
                                  <FormGroup>
                                    {/* <div
                                      onKeyPress={(e) => inputOnChange(e)}
                                      className="Appy"
                                    >
                                      <Select
                                        className="react-select primary"
                                        classNamePrefix="react-select"
                                        name="item"
                                        onChange={(value) =>
                                          handleSelectChange(value, poItem.id)
                                        }
                                        options={searchMedicineList}
                                        placeholder="Medication Name"
                                        ref={(ref) => setInputRef(ref, index)}
                                        value={poItem.item}
                                        noOptionsMessage={() =>
                                          "Type Item Name"
                                        }
                                      />
                                    </div> */}
                                    <AsyncSelect
                                      className="react-select primary"
                                      classNamePrefix="react-select"
                                      name="item"
                                      value={poItem.item}
                                      onChange={(value) =>
                                        handleMedicineSelectChange(
                                          value,
                                          poItem.id
                                        )
                                      }
                                      loadOptions={loadMedicationOptions}
                                      cacheOptions
                                      defaultOptions={false}
                                      ref={(ref) => setInputRef(ref, index)}
                                      placeholder="Medication"
                                      noOptionsMessage={() =>
                                        "Type Item Name or Code or Barcode"
                                      }
                                    />
                                  </FormGroup>
                                  <FormGroup
                                    style={{
                                      marginLeft: "-5px",
                                    }}
                                  >
                                    <FormControl
                                      type="text"
                                      name="description"
                                      placeholder="Description "
                                      onChange={(e) =>
                                        handleDescriptionChange(e, poItem.id)
                                      }
                                      value={poItem.description}
                                    />
                                  </FormGroup>
                                  {!!poItem.medicineError &&
                                    poItem.medicineError}
                                </td>
                                <td
                                  style={{
                                    width: "5%",
                                  }}
                                >
                                  <span>
                                    <FormGroup>
                                      <FormControl
                                        type="number"
                                        name="qty"
                                        onWheel={(e) => e.target.blur()}
                                        min={1}
                                        placeholder="Qty "
                                        onChange={(e) =>
                                          handleQtyChange(e, poItem.id)
                                        }
                                        value={poItem.qty}
                                      />
                                    </FormGroup>
                                    {!!poItem.qtyError && poItem.qtyError}
                                    {!!poItem.item && (
                                      <p
                                        style={{
                                          marginLeft: "10px",
                                          fontSize: "12px",
                                          color: "rgb(255, 138, 38)",
                                        }}
                                      >
                                        Available Stock {poItem.availableStock}
                                      </p>
                                    )}
                                  </span>
                                </td>
                                <td style={{ width: "8%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="number"
                                      name="unit_price"
                                      placeholder="Unit Price "
                                      value={Number(poItem.unit_price) || ""}
                                      onChange={(e) =>
                                        handleUnitPriceChange(e, poItem.id)
                                      }
                                      onWheel={(e) => e.target.blur()}
                                    />
                                  </FormGroup>
                                  {!!poItem.unitPriceError &&
                                    poItem.unitPriceError}
                                </td>
                                <td style={{ width: "4%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="number"
                                      name="discount"
                                      placeholder="Discount "
                                      onChange={(e) =>
                                        handleDiscountChange(e, poItem.id)
                                      }
                                      onWheel={(e) => e.target.blur()}
                                      value={poItem.discount || ""}
                                    />
                                  </FormGroup>
                                </td>
                                <td style={{ width: "4%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="number"
                                      name="free_of_good"
                                      placeholder="Free "
                                      onChange={(e) =>
                                        handleFreeOfGoodChange(e, poItem.id)
                                      }
                                      onWheel={(e) => e.target.blur()}
                                      value={poItem.free_of_good || ""}
                                    />
                                  </FormGroup>
                                </td>
                                {/* <td style={{ width: "10%", paddingTop: "5px" }}>
                            <FormGroup>
                              <Select
                                className="react-select primary"
                                classNamePrefix="react-select"
                                name="account"
                                placeholder="Account"
                                options={accountOption}
                                value={poItem.account}
                                onChange={(value) =>
                                  handleAccountChange(value, poItem.id)
                                }
                              />
                            </FormGroup>
                            {!!poItem.accountError && poItem.accountError}
                          </td> */}
                                <td style={{ width: "8%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="number"
                                      name="pack_size"
                                      placeholder="Pack Size "
                                      value={poItem.pack_size || ""}
                                      onChange={(e) =>
                                        handlePackSizeChange(e, poItem.id)
                                      }
                                      onWheel={(e) => e.target.blur()}
                                    />
                                  </FormGroup>
                                </td>
                                <td style={{ width: "8%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="number"
                                      name="pack_price"
                                      placeholder="Pack Price "
                                      value={poItem.pack_price || ""}
                                      onChange={(e) =>
                                        handlePackPriceChange(e, poItem.id)
                                      }
                                      onWheel={(e) => e.target.blur()}
                                    />
                                  </FormGroup>
                                </td>
                                <td style={{ width: "8%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="number"
                                      name="selling_price"
                                      placeholder="Selling Price "
                                      value={
                                        poItem.selling_price
                                          ? `${poItem.selling_price.toFixed(2)}`
                                          : ""
                                      }
                                      disabled
                                      onWheel={(e) => e.target.blur()}
                                      onChange={(e) =>
                                        handleSellingPriceChange(e, poItem.id)
                                      }
                                    />
                                  </FormGroup>
                                </td>
                                <td style={{ width: "10%" }}>
                                  <FormGroup>
                                    <FormControl
                                      type="number"
                                      name="amount"
                                      placeholder="Amount "
                                      value={poItem.amount.toFixed(2)}
                                      disabled
                                      onWheel={(e) => e.target.blur()}
                                    />
                                  </FormGroup>
                                </td>
                                <td>
                                  <Button
                                    onClick={() => handleRemoveClick(poItem.id)}
                                    style={{
                                      border: "none",
                                      marginBottom: "10px",
                                    }}
                                  >
                                    <i
                                      class="fa fa-times-circle"
                                      aria-hidden="true"
                                    ></i>
                                  </Button>
                                </td>
                                {poItem.item_code &&
                                (poItem.barcode !== null
                                  ? poItem.barcode.trim()[0] == "F"
                                  : true) ? (
                                  <>
                                    <td>
                                      <OverlayTrigger
                                        placement="top"
                                        overlay={barcodenotification}
                                      >
                                        <Button
                                          onClick={() => onPrintClick(index)}
                                          style={{
                                            border: "none",
                                            marginBottom: "10px",
                                          }}
                                        >
                                          <i
                                            class="fa fa-barcode"
                                            aria-hidden="true"
                                          ></i>
                                        </Button>
                                      </OverlayTrigger>
                                    </td>
                                    <td style={{ display: "none" }}>
                                      <div
                                        ref={(ref) =>
                                          setBarcodeRefs(ref, index)
                                        }
                                        className="print-only"
                                      >
                                        <BarcodeInput
                                          name={poItem.item.label}
                                          itemcode={poItem.item_code}
                                        />
                                      </div>
                                    </td>
                                  </>
                                ) : (
                                  ""
                                )}
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </>
                )}
                {supplierValue && (
                  <>
                    <Button
                      style={{ marginLeft: "12px" }}
                      onClick={() => handleAddClick()}
                    >
                      Add New Line
                    </Button>
                    <Button
                      style={{ marginLeft: "15px" }}
                      className="btn btn-fill"
                      onClick={() => setIsOpen(true)}
                    >
                      <i
                        className="fa fa-plus"
                        style={{ marginRight: "5px" }}
                      ></i>{" "}
                      Add New Medicine
                    </Button>
                    <Row>
                      <div
                        style={{
                          display: "flex",
                          float: "right",
                          marginRight: "100px",
                          gap: "40px",
                        }}
                      >
                        <div>
                          <h5>
                            <b>Total</b>
                          </h5>
                        </div>
                        <div>
                          <h5>{poTotal.toFixed(2)}</h5>
                        </div>
                      </div>
                    </Row>
                    <hr />
                    <Row>
                      <Col md={12} xs={12} sm={12} lg={12}>
                        <div
                          style={{
                            background: "#EEEEEE",
                            padding: "10px",
                            borderRadius: "10px",
                          }}
                        >
                          <h3>Good Return Note</h3>
                          <br />
                          <Button
                            style={{ float: "right" }}
                            className="btn btn-fill btn btn-default"
                            onClick={handleRemoveValues}
                          >
                            Clear
                          </Button>

                          <div
                            style={{
                              display: "flex",
                              gap: "20px",
                            }}
                          >
                            <Select
                              name="getDeliveryReason"
                              value={getDeliveryReason}
                              placeholder="Search Status"
                              onChange={handleGetDeliveryReason}
                              options={[
                                { value: "Wrong Goods", label: "Wrong Goods" },
                                {
                                  value: "Excess Goods",
                                  label: "Excess Goods",
                                },
                                {
                                  value: "Damage Goods",
                                  label: "Damage Goods",
                                },
                                { value: "Other", label: "Other" },
                              ]}
                              styles={{
                                container: (base) => ({
                                  ...base,
                                  width: "220px",
                                }),
                              }}
                            />
                            {getDeliveryReason &&
                            getDeliveryReason.value === "Other" ? (
                              <textarea
                                style={{ width: "20%" }}
                                className="form-control"
                                value={otherOption}
                                name="otherOption"
                                onChange={(e) => setOtherOption(e.target.value)}
                                placeholder="Enter other reason"
                              ></textarea>
                            ) : (
                              ""
                            )}
                          </div>
                          <br />
                          <Col md={12} style={{ marginBottom: "5px" }}>
                            <div
                              className="table-responsive"
                              style={{ marginBottom: "5px" }}
                            >
                              <Table
                                style={{
                                  width: "100%",
                                }}
                              >
                                <thead>
                                  <tr>
                                    <th
                                      style={{
                                        width: "30%",
                                        textAlign: "center",
                                      }}
                                    >
                                      <ControlLabel>Medicine Name</ControlLabel>
                                    </th>

                                    <th
                                      style={{
                                        width: "30%",
                                        textAlign: "center",
                                      }}
                                    >
                                      <ControlLabel>Unit Price</ControlLabel>
                                    </th>
                                    <th
                                      style={{
                                        width: "30%",
                                        textAlign: "center",
                                      }}
                                    >
                                      <ControlLabel>Quantity</ControlLabel>
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {rows.length === 0 ? (
                                    <tr>
                                      <td
                                        colSpan={4}
                                        style={{ textAlign: "center" }}
                                      >
                                        <span
                                          style={{
                                            fontFamily: "sans-serif",
                                            textAlign: "center",
                                            fontSize: "13px",
                                            fontWeight: 100,
                                          }}
                                        >
                                          {" "}
                                          No medication added
                                        </span>
                                      </td>
                                    </tr>
                                  ) : (
                                    rows.map((row, index) => (
                                      <tr key={index}>
                                        <td style={{ width: "30%" }}>
                                          <Select
                                            placeholder="Search medicine"
                                            value={
                                              row.selectedOption &&
                                              row.selectedOption.label &&
                                              row.selectedOption.value
                                                ? row.selectedOption
                                                : null
                                            }
                                            onChange={(selected) =>
                                              handleSelectChanges(
                                                selected,
                                                index
                                              )
                                            }
                                            onInputChange={(inputValue) =>
                                              handleInputChange(inputValue)
                                            }
                                            options={medications}
                                            isClearable
                                            isSearchable
                                            noOptionsMessage={() =>
                                              "No results"
                                            }
                                          />
                                        </td>
                                        <td style={{ width: "30%" }}>
                                          <FormControl
                                            isDisabled
                                            placeholder="Unit Price"
                                            value={
                                              row.selectedOption &&
                                              row.selectedOption.unitPrice
                                            }
                                            readOnly
                                          />
                                        </td>
                                        <td style={{ width: "30%" }}>
                                          <FormControl
                                            name="qty"
                                            value={row.qty}
                                            type="number"
                                            min="1"
                                            placeholder="Enter Quantity"
                                            onWheel={(e) => e.target.blur()}
                                            onBlur={(e) =>
                                              handleQtyBlur(e, index)
                                            }
                                            onChange={(e) =>
                                              handleQtyChanges(e, index)
                                            }
                                          />
                                        </td>
                                        <td style={{ width: "10%" }}>
                                          <a
                                            href="#"
                                            onClick={() =>
                                              handleRemoveRow(index)
                                            }
                                          >
                                            X
                                          </a>
                                        </td>
                                      </tr>
                                    ))
                                  )}
                                </tbody>
                              </Table>
                            </div>
                          </Col>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              className="btn btn-default"
                              style={{ marginTop: "10px" }}
                              onClick={handleAddRow}
                            >
                              <i className="fa fa-plus"></i> Add Medicine
                            </Button>
                          </div>
                        </div>
                      </Col>
                    </Row>
                    <br />
                    <Row>
                      <Col md={12} xs={12} sm={12}>
                        <ControlLabel>Delivery Instruction</ControlLabel>

                        <textarea
                          className="form-control"
                          rows="4"
                          cols="5"
                          name="note"
                          onChange={(e) => handleDeliveryInstructionChange(e)}
                        />
                      </Col>
                    </Row>
                    <br />
                    <br />
                    <Row>
                      <Col md={12} xs={12} sm={12}>
                        <div
                          className="collapeablecomp_orderhistory"
                          style={{
                            backgroundColor: "#D7FFDB",
                            padding: "10px",
                            borderRadius: "5px",
                          }}
                        >
                          <Collapsible
                            trigger="PO History"
                            transitionTime={200}
                            onOpen={() => {
                              showPOHistoryData();
                            }}
                          >
                            <Table responsive>
                              <thead>
                                <tr>
                                  <th>PO ID</th>
                                  <th>Name</th>
                                  <th>Order Date</th>
                                  <th>Total Cost</th>
                                  <th className="text-right">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {purchaseOrderHistory &&
                                purchaseOrderHistory.length === 0 ? (
                                  <tr>
                                    <td colspan="10">
                                      <center>No record found</center>
                                    </td>
                                  </tr>
                                ) : (
                                  <React.Fragment>
                                    {purchaseOrderHistory &&
                                      purchaseOrderHistory.map(
                                        (poHistory, key) => (
                                          <tr key={key}>
                                            <td>{poHistory.id}</td>
                                            <td>{poHistory.supplier.name}</td>
                                            <td>{poHistory.created_at}</td>
                                            <td>
                                              {handlePOHistoryItemTotal(
                                                poHistory.order_items
                                              )}
                                            </td>
                                            <td className="text-right">
                                              {" "}
                                              <OverlayTrigger
                                                placement="top"
                                                overlay={view}
                                              >
                                                <Button
                                                  simple
                                                  bsStyle="info"
                                                  onClick={() => {
                                                    showPoItemsModal(
                                                      poHistory.order_items,
                                                      poHistory.id
                                                    );
                                                  }}
                                                  bsSize="sm"
                                                >
                                                  <i className="fa fa-user" />
                                                </Button>
                                              </OverlayTrigger>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                  </React.Fragment>
                                )}
                              </tbody>
                            </Table>
                          </Collapsible>
                        </div>
                      </Col>
                    </Row>
                  </>
                )}
                <br />
                <Row>
                  <Col>
                    <Button
                      class="btn-color"
                      onClick={() => handleOnSubmit()}
                      fill="true"
                      disabled={disableSubmitButton}
                    >
                      Submit
                    </Button>
                  </Col>
                </Row>
              </form>
            </>
          }
        />
        <Modal
          show={POHistoryOrderItemsModalShow}
          onHide={() => {
            setPOHistoryOrderItemsModalShow(false);
            setPurchaseOrderHistoryOrderItems([]);
          }}
        >
          <>
            <Modal.Header closeButton>
              <Modal.Title>Medication Details</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Table>
                <thead>
                  <tr>
                    <th>Medication</th>
                    <th>Unit Price</th>
                    <th>Quantity</th>
                    <th>Discount %</th>
                    <th>Free of goods</th>
                  </tr>
                </thead>
                <tbody>
                  {purchaseOrderHistoryOrderItems &&
                    purchaseOrderHistoryOrderItems.map((data) => (
                      <tr key={data.medication_id}>
                        <td>{data.medicine.title}</td>
                        <td>{Number(data.amount - 0).toFixed(2)}</td>
                        <td>{data.quantity}</td>
                        <td>{Number(data.discount)}</td>
                        <td>{data.free_of_goods}</td>
                      </tr>
                    ))}
                </tbody>
              </Table>
            </Modal.Body>
          </>
        </Modal>
      </Grid>
      {isOpen && (
        <AddMedicationModal
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          selectedMedicationCategory={selectedMedicationCategory}
          setSelectedMedicationCategory={setSelectedMedicationCategory}
          medicationName={medicationName}
          setMedicationName={setMedicationName}
          handleAddMedication={handleAddMedication}
          medicationModalCategoryError={medicationModalCategoryError}
          medicationModalNameError={medicationModalNameError}
          setMedicationModalCategoryError={setMedicationModalCategoryError}
          setMedicationModalNameError={setMedicationModalNameError}
          isLoading={isLoading}
          setIsLoading={setIsLoading}
        />
      )}
    </>
  );
};

export default AddPo;